export const STORAGE_KEYS = { SESSION: "topgrade.session" };

export const APP_CONFIG = {
  // kakaoJsKey: 웹 카카오 간편로그인용 JavaScript 키.
  //   ⚠️ kakaoRestKey와 '같은 카카오 앱'의 JS 키여야 함(kakaoCustomToken CF가 같은 앱 기준으로 검증).
  //   아래 값은 지도용 키라 앱이 다르면 교체 필요.
  social: { googleWebClientId: "", kakaoNativeKey: "", kakaoJsKey: "f3884aa215c7467194b2bdaa264ec201" },
  sms: { cfUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/api/AuthCodeSend", label: "1등급" },
  testRange: { start: "01062141000", end: "01062141005" },
  kakaoCustomTokenUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/kakaoCustomToken",
  kakaoRestKey: "7832790aeece53a32c2da7c1248a033b",
  deleteAccountUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/deleteAccount",
  devLoginTokenUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/devLoginToken",
  createDemoSessionUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/createDemoSession",
  appleCustomTokenUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/appleCustomToken",
  resetPasswordUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/resetPassword",
  resolveParentLinksUrl: "https://asia-northeast3-grade-3d350.cloudfunctions.net/resolveParentLinks",
};
